import { render, staticRenderFns } from "./MainLanguage.vue?vue&type=template&id=b6ea7aa8&"
import script from "./MainLanguage.vue?vue&type=script&lang=js&"
export * from "./MainLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports